import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { Section, Callout, Strong, legalUl, useLegalLink } from './LegalLayout';

const EMAIL = 'vmdpproject@gmail.com';

export const ICOACH_THEME = {
  accent: '#22d3ee',
  rgb: '34,211,238',
  gradient: 'linear-gradient(135deg, #22d3ee 0%, #67e8f9 100%)',
  appName: 'iCoach',
  base: '/icoach',
};

function Body() {
  const link = useLegalLink();
  return (
    <>
      <Section n={1} title="Descrizione del Servizio">
        iCoach Exclusive Lab è un'applicazione mobile per il fitness e il coaching personalizzato, sviluppata da VMDProject. La piattaforma offre piani di allenamento personalizzati, tracciamento dei progressi, sessioni di coaching con trainer certificati e strumenti di analisi delle performance basati su intelligenza artificiale.
      </Section>

      <Section n={2} title="Accettazione dei Termini">
        Scaricando, installando o utilizzando iCoach accettate integralmente i presenti Termini e Condizioni, nonché la nostra <Link to="/icoach/policy" style={link}>Privacy Policy</Link>. Se non accettate questi termini, non utilizzate l'applicazione. L'utilizzo è consentito esclusivamente a persone fisiche di età pari o superiore a 16 anni.
      </Section>

      <Section n={3} title="Account e Registrazione">
        <ul style={legalUl}>
          <li>La creazione di un account richiede un indirizzo email valido e una password sicura.</li>
          <li>Siete responsabili della riservatezza delle credenziali di accesso e di tutte le attività effettuate tramite il vostro account.</li>
          <li>Ogni account è personale e non trasferibile.</li>
          <li>VMDProject si riserva il diritto di sospendere o eliminare account che violino i presenti Termini.</li>
        </ul>
      </Section>

      <Section n={4} title="Abbonamenti e Pagamenti">
        <ul style={legalUl}>
          <li>iCoach offre piani di abbonamento mensili e annuali, i cui prezzi aggiornati sono disponibili nell'applicazione.</li>
          <li>I pagamenti sono elaborati tramite Apple App Store o Google Play Store. VMDProject non accede direttamente ai dati di pagamento.</li>
          <li>Gli abbonamenti si rinnovano automaticamente al termine del periodo, salvo disdetta effettuata almeno 24 ore prima del rinnovo dalle impostazioni dello store.</li>
          <li>Non sono previsti rimborsi per i periodi di abbonamento già iniziati, salvo diversa disposizione di Apple o Google o obbligo di legge.</li>
        </ul>
      </Section>

      <Section n={5} title="Avvertenze Sanitarie">
        <Callout>
          <Strong>Avviso importante:</Strong> iCoach è uno strumento di supporto al fitness e non costituisce consulenza medica, nutrizionale o terapeutica. Prima di iniziare qualsiasi programma di allenamento, consultate il vostro medico, in particolar modo in presenza di patologie cardiache, ortopediche o metaboliche.
        </Callout>
        VMDProject declina ogni responsabilità per infortuni, danni alla salute o conseguenze derivanti dall'uso dei programmi di allenamento forniti dall'applicazione.
      </Section>

      <Section n={6} title="Responsabilità dell'Utente">
        Utilizzando iCoach l'utente si impegna a:
        <ul style={legalUl}>
          <li>Fornire informazioni accurate sul proprio stato di salute e livello di forma fisica.</li>
          <li>Non caricare contenuti illegali, offensivi o che violino i diritti di terzi.</li>
          <li>Non tentare di accedere in modo non autorizzato ai sistemi o agli account di altri utenti.</li>
          <li>Non utilizzare l'applicazione per scopi commerciali senza autorizzazione scritta.</li>
        </ul>
      </Section>

      <Section n={7} title="Contenuti e Proprietà Intellettuale">
        Tutti i contenuti dell'applicazione iCoach — inclusi piani di allenamento, testi, immagini, video, schede tecniche e il codice sorgente — sono di esclusiva proprietà di VMDProject o dei suoi licenziatari e sono protetti dalle normative italiane ed europee sul diritto d'autore. È vietata qualsiasi riproduzione, distribuzione o commercializzazione senza autorizzazione scritta preventiva.
      </Section>

      <Section n={8} title="Limitazione di Responsabilità">
        Nei limiti consentiti dalla legge applicabile, VMDProject non sarà responsabile per:
        <ul style={legalUl}>
          <li>Danni diretti o indiretti derivanti dall'uso o dall'impossibilità di utilizzo dell'applicazione.</li>
          <li>Interruzioni del servizio per manutenzione programmata o cause di forza maggiore.</li>
          <li>Perdita di dati dovuta a malfunzionamenti del dispositivo dell'utente.</li>
          <li>Risultati di allenamento non raggiunti.</li>
        </ul>
      </Section>

      <Section n={9} title="Modifiche al Servizio e ai Termini">
        VMDProject si riserva il diritto di modificare, aggiornare o interrompere il servizio in qualsiasi momento, così come di aggiornare i presenti Termini. Le modifiche sostanziali saranno comunicate tramite notifica in-app o via email. L'uso continuato dell'applicazione dopo la pubblicazione delle modifiche costituisce accettazione dei nuovi Termini.
      </Section>

      <Section n={10} title="Risoluzione del Contratto">
        L'utente può eliminare il proprio account in qualsiasi momento tramite le impostazioni dell'app o scrivendo a <a href={`mailto:${EMAIL}`} style={link}>{EMAIL}</a>. VMDProject può risolvere il contratto e sospendere l'accesso in caso di violazione dei presenti Termini.
      </Section>

      <Section n={11} title="Legge Applicabile e Foro Competente">
        I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia derivante dall'utilizzo di iCoach è competente in via esclusiva il Tribunale di Napoli, salvo diversa previsione obbligatoria di legge a favore del consumatore.
      </Section>

      <Section n={12} title="Contatti">
        Per qualsiasi domanda relativa ai presenti Termini e Condizioni:
        <br /><br />
        <Strong>VMDProject</Strong> — Napoli, Italia
        <br />
        Email: <a href={`mailto:${EMAIL}`} style={link}>{EMAIL}</a>
      </Section>
    </>
  );
}

export default function IcoachTerms() {
  return (
    <LegalLayout
      {...ICOACH_THEME}
      eyebrow="// icoach · termini di servizio"
      title="Termini e"
      highlight="Condizioni"
      meta="iCoach Exclusive Lab · Ultimo aggiornamento: maggio 2026"
      intro={
        <>
          <Strong>Leggere attentamente.</Strong> L'uso dell'applicazione iCoach comporta l'accettazione integrale dei presenti Termini e Condizioni. iCoach non sostituisce il parere di un medico o di un professionista della salute.
        </>
      }
    >
      <Body />
    </LegalLayout>
  );
}
